/* Sticky bottom CTA bar — visible on mobile only, always-on conversion bar. */
import { Link, useLocation } from "react-router-dom";
import { Calendar, MessageCircle } from "lucide-react";
import { WHATSAPP_LINK, openWhatsApp } from "@/data/site";

const HIDE_ON = ["/booking", "/payment", "/admin"];

export default function StickyMobileCTA() {
    const loc = useLocation();
    const hidden = HIDE_ON.some((p) => loc.pathname.startsWith(p));
    if (hidden) return null;

    return (
        <div className="lg:hidden fixed bottom-0 left-0 right-0 z-30 border-t border-gold/20 bg-ink-deep/95 backdrop-blur-xl px-4 py-3 grid grid-cols-2 gap-3" data-testid="sticky-mobile-cta">
            <a
                href={WHATSAPP_LINK}
                onClick={openWhatsApp}
                target="_blank"
                rel="noreferrer"
                className="flex items-center justify-center gap-2 rounded-full border border-gold/40 text-cream py-2.5 text-sm font-medium hover:bg-gold/10"
                data-testid="sticky-whatsapp"
            >
                <MessageCircle className="h-4 w-4 text-gold" /> WhatsApp
            </a>
            <Link
                to="/booking"
                className="flex items-center justify-center gap-2 rounded-full bg-gold-gradient text-ink py-2.5 text-sm font-semibold hover:opacity-95"
                data-testid="sticky-book"
            >
                <Calendar className="h-4 w-4" /> Book Now
            </Link>
        </div>
    );
}
